'use client';

import { PageNavigation } from '@/components/client';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';

import { CartIconLink } from '../../_components/CartIconLink';

export const GiftsPageNavigation = () => {
  const router = useCustomRouter();

  return (
    <PageNavigation
      donationHomeButton
      isNotUsedHomeButton
      searchForm
      searchFormClassName="cursor-pointer"
      onSearchFormClick={() => {
        router.push(
          ROUTES.SEARCH.withSearchParams({
            searchParams: { category: 'gifts' },
          }),
        );
      }}
    >
      <CartIconLink className="ml-10 self-center" />
    </PageNavigation>
  );
};
